var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":16,"draggable":true}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }